import { render, staticRenderFns } from "./TerminalDrawingBoard.vue?vue&type=template&id=19e936fe&"
import script from "./TerminalDrawingBoard.vue?vue&type=script&lang=js&"
export * from "./TerminalDrawingBoard.vue?vue&type=script&lang=js&"
import style0 from "./TerminalDrawingBoard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports